export default __webpack_public_path__ + "static/media/biofit-builder-series-sceptor.ff373ac6.png";